import {Component, OnInit} from '@angular/core';
import * as _ from 'lodash';

import { AuthenticationService } from './shared/services/authentication.service';
import { LoaderService } from './shared/services/loader.service';
import {EntitiesService} from './shared/services/entitiesService.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  user: any;
  todoActivityStatus: string;
  totalToDoActivities: number;

  get auth() { return this._auth; }
  get isLoading() {
    return this.loader.isLoading;
  }

  constructor(
    private _auth: AuthenticationService,
    private loader: LoaderService,
    private entitiesService: EntitiesService,
  ) {

  }

  ngOnInit() {
    this.user = this._auth.getUser();
    this.getActivityRecords();

  }

  getActivityRecords() {
    const query: any = {
      skip: 0,
      limit: 1,
      type: 'todo',
    };

    query['assignee._id'] = this.user._id;
    query[`sort[dueDate]`] = 1;

    this.entitiesService.getActivityRecords(query).subscribe(res => {
      const activity = _.get(res, 'data.0');
      if (!activity) {
        return null;
      }

      this.todoActivityStatus = this._getDaysBetweenDates(new Date(activity.dueDate), new Date());
      this.totalToDoActivities = res.count;
    });
  }

  _getDaysBetweenDates(dueData, now) {
    if (
      dueData.getFullYear() === now.getFullYear() &&
      dueData.getMonth() === now.getMonth() &&
      dueData.getDate() === now.getDate()
    ) {
      return 'success';
    }

    if (
      dueData.getFullYear() < now.getFullYear() ||
      (dueData.getFullYear() === now.getFullYear() && dueData.getMonth() < now.getMonth()) ||
      (
        dueData.getFullYear() === now.getFullYear() &&
        dueData.getMonth() === now.getMonth() &&
        dueData.getDate() < now.getDate()
      )
    ) {
      return 'danger';
    }

    return '';
  }
}
